import { faEllipsisVertical, faBan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useInvoicesPermissions } from '../../hooks/useInvoicesPermissions';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { Button } from '@shared/components/ui/button';

interface BlockedShipmentDropdownActionsProps {
  blockId: number; // ID del registro de bloqueo (accounting_shipment_blocks.id)
  onAction?: (action: string, blockId: number) => void;
}

/**
 * Componente de acciones para shipments bloqueados
 * Muestra la opción de Desbloquear
 */
export const BlockedShipmentDropdownActions = ({ blockId, onAction }: BlockedShipmentDropdownActionsProps) => {
  const { t } = useTranslation('invoicesOrdersModule');

  // 🔒 Verificar permisos con hook específico de Invoices
  // Para desbloquear se necesita el permiso shipments.unblock (canRestoreLines)
  const { canRestoreLines } = useInvoicesPermissions();

  const handleAction = (actionType: string) => {
    if (onAction) {
      onAction(actionType, blockId);
    }
  };

  if (!canRestoreLines) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0" data-testid="blocked-shipment-dropdown-trigger">
          <FontAwesomeIcon icon={faEllipsisVertical} className="text-icons" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-48 border-card-border"
        data-testid="blocked-shipment-dropdown-content"
      >
        <DropdownMenuItem
          onClick={() => handleAction('unblock')}
          className="whitespace-nowrap"
          data-testid="blocked-shipment-action-unblock"
        >
          <FontAwesomeIcon icon={faBan} className="mr-1 !w-3 !h-3 !text-content-primary" />
          {t('actions.unblock', 'Desbloquear')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
